export const ROUTES = {
	home: "/",
	aboutUs: "/about-us",
	services: "/services",
	serviceDetails: "/services/service-details",
	portfolio: "/portfolio",
	portfolioDetails: "/portfolio/portfolio-details",
	team: "/team",
	teamDetails: "/team/team-details",
	blogsGrid: "/blogs",
	blogsList: "/blogs-list",
	blogDetails: "/blogs/blog-details",
	faq: "/faq",
	pricing: "/pricing",
	testimonial: "/testimonial",
	contactPage: "/contact-me",
	makeAnAppointment: "/make-an-appointment",
	errorPage: "/404",
	comingSoon: "/coming-soon",
};
